/**
 * Gọi Zalo API để lấy access token từ oauth code
 * 
 * ⚠️ LƯU Ý: Secret key không nên để ở frontend. 
 * Function này chỉ dùng cho mục đích test/development.
 * Trong production, nên gọi qua backend API.
 */
export async function getZaloAccessToken(
  oauthCode: string,
  codeVerifier: string,
  appId: string,
  secretKey: string
): Promise<{
  access_token?: string;
  refresh_token?: string;
  expires_in?: number;
  error?: number;
  error_description?: string;
}> {
  const formData = new URLSearchParams();
  formData.append("code", oauthCode);
  formData.append("app_id", appId);
  formData.append("grant_type", "authorization_code");
  formData.append("code_verifier", codeVerifier);

  try {
    const response = await fetch("https://oauth.zaloapp.com/v4/access_token", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        secret_key: secretKey,
      },
      body: formData.toString(),
    });

    const data = await response.json();
    return data;
  } catch (error: any) {
    console.error("Error getting Zalo access token:", error);
    throw error;
  }
}


export async function getZaloUserInfo(accessToken: string): Promise<any> {
  try {
    const response = await fetch("https://graph.zalo.me/v2.0/me?fields=id,name,picture", {
      method: "GET",
      headers: {
        access_token: accessToken,
      },
    });

    const data = await response.json();
    return data;
  } catch (error: any) {
    console.error("Error getting Zalo user info:", error);
    throw error;
  }
}

